<dx-popup
    #transferPaymentEditorBox
    width="55%"
    height="75%"
    title="Transfer and Split Payment"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="ar-transfer-payment-editor-content">
        <dx-box width="100%" height="100%" direction="col" *ngIf="!!paymentTransferResultData">
            <dxi-item baseSize="auto">
                <dx-form width="100%" height="100%" [colCount]="1">
                    <dxi-item>
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                [width]="100"
                                [min]="paymentTransferResultData.minPostDate"
                                [(value)]="transferPaymentInfo.postDate"
                                type="date"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Payment Amount"></dxo-label>
                        <div *dxTemplate>
                            {{ paymentTransferResultData.amount | ccCurrency }}
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div class="add-button-container">
                    <dx-button type="default" [icon]="addIcon" text="Add" (onClick)="onAddClick()"></dx-button>
                </div>
                <cc-data-grid-features
                    [stateConfig]="{ storageKey: 'PAYMENT_TRANSFER_EDITOR_GRID' }"
                    [gridFeatures]="{
                        stylingMode: 'hidden',
                        allowSearch: false,
                        allowRowFilters: false,
                        allowHeaderFilters: false,
                        allowGrouping: false
                    }"
                    [pagingConfig]="{ visible: false }"
                    [dataSource]="transferPaymentInfo?.transferAccounts"
                >
                    <dx-data-grid
                        #paymentTransferEditorGrid
                        width="100%"
                        height="100%"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [showColumnLines]="true"
                        [wordWrapEnabled]="true"
                        [rowAlternationEnabled]="false"
                        [columnAutoWidth]="true"
                        [dataSource]="transferPaymentInfo?.transferAccounts"
                    >
                        <dxi-column type="buttons" caption="" alignment="center" [showInColumnChooser]="false">
                            <dxi-button template="template">
                                <div *dxTemplate="let row of 'template'" class="cc-action-button">
                                    <dx-drop-down-button
                                        class="dropdown-button icon-button-content"
                                        text="Actions"
                                        icon="runner"
                                        dropDownContentTemplate="dropDownContentTemplate"
                                        [showArrowIcon]="true"
                                    >
                                        <div
                                            *dxTemplate="let content of 'dropDownContentTemplate'"
                                            class="content-container"
                                        >
                                            <div class="option-menu">
                                                <dx-button
                                                    class="dropdown-menu-button"
                                                    text="Edit"
                                                    type="default"
                                                    (onClick)="onEditClick(row.data)"
                                                ></dx-button>
                                                <dx-button
                                                    class="dropdown-menu-button"
                                                    text="Delete"
                                                    type="danger"
                                                    (onClick)="onDeleteClick(row.data)"
                                                ></dx-button>
                                            </div>
                                        </div>
                                    </dx-drop-down-button>
                                </div>
                            </dxi-button>
                        </dxi-column>
                        <dxi-column dataField="communityName" caption="Community" dataType="string"></dxi-column>
                        <dxi-column dataField="accountName" caption="Account" dataType="string"></dxi-column>
                        <dxi-column
                            caption="Debit Description"
                            dataType="string"
                            dataField="debitAccountDescription"
                        ></dxi-column>
                        <dxi-column
                            caption="Credit Description"
                            dataType="string"
                            dataField="creditAccountInfo.description"
                        ></dxi-column>
                        <dxi-column
                            [width]="90"
                            caption="Amount"
                            dataType="number"
                            dataField="transferAmount"
                            [format]="currencyFormat"
                        ></dxi-column>
                    </dx-data-grid>
                </cc-data-grid-features>
            </dxi-item>

            <dxi-item baseSize="auto">
                <dx-form width="100%" height="100%" [colCount]="1">
                    <dxi-item>
                        <dxo-label text="Total Transfer"></dxo-label>
                        <div *dxTemplate class="total-tansfer">
                            {{ totalTransfer | ccCurrency }}
                        </div>
                    </dxi-item>
                </dx-form>
                <dx-toolbar width="100%" class="button-container">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Close"
                                [icon]="closeIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Transfer Payment"
                                (onClick)="onTransferPaymentClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-add-transfer-account
    *ngIf="displayAddTransferAccount"
    [visible]="displayAddTransferAccount"
    [transferAccountParam]="transferPaymentInfo"
    [availableAmount]="paymentTransferResultData.amount"
    [documentNo]="documentNo"
    [action]="action"
    [editTransferAccount]="editTransferAccount"
    (onAddTransferAccountClose)="onAddTransferAccountClose($event)"
></app-add-transfer-account>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#transferPaymentEditorBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
